export const rm = (n) => "RM " + Number(n || 0).toLocaleString("en-MY", { maximumFractionDigits: 2 });
export const num = (n) => Number(n || 0).toLocaleString("en-MY");
export const fmt = (v, format) => {
  if (format === "rm") return rm(v);
  if (format === "x") return Number(v).toFixed(2) + "x";
  return num(v);
};
